export const SUPPORTED_LOCALES = ['en', 'am'] as const
export type AppLocale = (typeof SUPPORTED_LOCALES)[number]
export const DEFAULT_LOCALE: AppLocale = 'en'

/** BCP 47 tags used for Intl date/number/currency formatting. */
export const INTL_LOCALE: Record<AppLocale, string> = {
  en: 'en-GB',
  am: 'am-ET',
}

export function isSupportedLocale(value: string): value is AppLocale {
  return (SUPPORTED_LOCALES as readonly string[]).includes(value)
}
